import { TerminateTreatmentRequestPayload } from "@/data/payload/treatment/pause-treatment-request-payload";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class TerminateTreatmentUsecase {
  //MARK:- Constructor
  constructor(private readonly treatmentRepo: TreatmentRepository) {}

  //MARK:- execute
  async execute(treatmentInfoUuid: string): Promise<SATResult<void, SATError>> {
    const payload: TerminateTreatmentRequestPayload = { treatmentInfoUuid };
    const result = await this.treatmentRepo.terminateTreatment(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(void 0);
  }
}
